<template>
  <v-container>
    <v-row align="center" justify="center">
      <h1>{{$t('routes.index.helloUser')}}</h1>
    </v-row>

    <v-row align="center" justify="center">
      <h3 v-if="user && user.username">{{$t('routes.index.welcome', [user.username])}}</h3>
    </v-row>

    <v-row align="center" justify="center">
      <div class="link-container">
        <router-link to="/account/logout">{{$t('routes.index.logout')}}</router-link>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore.js'

export default {
  name: 'DefaultIndex',
  data() {
    return {
      redirectStarted: false,
    };
  },
  mounted: function() {
    // API.get('app', 'me').then(e => {e} /*console.log(e)*/);

    const authStore = useAuthStore();
    authStore.refreshCognitoUser();

    this.redirectToRoot();
  },
  watch: {
    getRootNodeId: function(oldValue, newValue) {
      if (!oldValue && newValue) {
        this.redirectToRoot();
      }
    },
    dbUser: function() {
      this.redirectToRoot();
    }
  },
  methods: {
    redirectToRoot: function() {
      // Redirect to access point
      if (this.dbUser && this.getRootNodeId && !this.redirectStarted) {
        this.redirectStarted = true;
        this.$router.push('/node/' + this.getRootNodeId);
      }

      // Redirecto to the management console
      if (this.dbUser && !this.getRootNodeId && !this.redirectStarted) {
        this.redirectStarted = true;
        this.$router.push('/console/index');
      }
    }
  },
  computed: {
    getRootNodeId() {
      const authStore = useAuthStore();
      return authStore.rootNodeId;
    },
    user: function() {
      const authStore = useAuthStore();
      return authStore.user;
    },
    dbUser: function() {
      const authStore = useAuthStore();
      return authStore.dbUser;
    }
  }
}
</script>
